<script>
    import Flex from "./Flex.vue";
    export default {
      name: "Column",
      components: {
        Flex
      },
      props: {
        modelKey: {
          type: String,
          default: ""
        },
        parentKey: null
      },
      render: function (createElement){
        let model = {...this.model}
        model.property.props.direction = "column"
        model.property.props.modelKey = this.modelKey
        model.property.props.parentKey = this.parentKey
        return createElement(Flex, this.model.property)
      },
      computed: {
        model(){
          return this.getModel(this.modelKey)
        }
      },
      methods: {
        getModel(item){
          return this.$clone((this.$store.getters.GetDomObjectContent(item) || {}))
        },
      }    
    };

</script>